import { getInstanceByDom } from 'echarts';
import { useEffect } from 'react';
import { debug } from 'zf-web-infra';
import { UseLoadingParams } from './types';

/**
 * 设置Charts的属性
 * @param params
 */
export function useLoading(params: UseLoadingParams): void {
  debug.common('useLoading');

  useEffect(() => {
    if (params.node.current == null) {
      return;
    }
    const chart = getInstanceByDom(params.node.current);
    if (chart != null) {
      params.loading === true ? chart.showLoading() : chart.hideLoading();
    }
  }, [params]);
}
